/**
 * This is overide the theme style max width for dialogs.
 * It should be put into @global to make it work.
 */
export const LargeModalWidth = {
  '.modal-dialog': {
    maxWidth: '900px',
  },
};

/**
 * This is default modal styles.
 * @returns {{modalWidth: {}}} the default modal width style
 */
export const getDefaultModalStyle = () => ({
  modalWidth: {
    maxWidth: '450px',
  },
});
